module.exports = __webpack_public_path__ + "static/media/cogwheel.cbccb2d5.png";